import { gunterzBold } from '@/theme/fonts';
import { Flex, NumberFormatter, Space, Text, rem } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import type { BunkerRewardItemType } from './data';
export const BunkerRewardItem: React.FC<BunkerRewardItemType> = ({
  percent,
  exp,
  multiplier,
  topDes,
  bottomDes
}) => {
  const isMobile = useMediaQuery('(max-width: 76em)');
  return <Flex align="center" justify="space-between" bd="1px solid var(--icon-primary)" p={{
    base: 10,
    sm: 16
  }} style={{
    borderRadius: 5
  }} direction={{
    lg: 'column'
  }}>
      <Text ta="center" c="var(--text-white)" className={gunterzBold.className} fz={{
      base: 14,
      sm: 18,
      lg: 23
    }} style={{
      order: isMobile ? 2 : 1,
      textWrap: 'nowrap'
    }} lh={{
      base: rem(16),
      sm: rem(20),
      lg: rem(25)
    }}>
        <NumberFormatter value={percent || exp || multiplier} suffix={percent ? '%' : multiplier ? 'X' : 'XP'} />
      </Text>

      <Flex direction={{
      base: 'column',
      sm: 'row',
      lg: 'column'
    }} style={{
      order: isMobile ? 1 : 2
    }}>
        <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)" style={{
        textWrap: 'nowrap'
      }} ta={{
        base: 'left',
        lg: 'center'
      }}>
          {topDes}
        </Text>
        <Space w={4} />
        <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)" style={{
        textWrap: 'nowrap'
      }} ta={{
        base: 'left',
        lg: 'center'
      }}>
          {bottomDes}
        </Text>
      </Flex>
    </Flex>;
};